<template>
  <div>
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span class="fontStyle1">{{ $t('QR.deviceSN') }}:{{ $route.query.sn }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('QR.ProductID') }}:{{ basicinfo.proCode }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('QR.Salesordernumber') }}:{{ basicinfo.saleno }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('QR.Dateofmanufacture') }}:{{ basicinfo.makeDate }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('QR.warrantyperiod') }}:{{ basicinfo.warrantyDate }}</span>
      </div>
    </el-row>
    <el-row style="background: #fff;padding: 13px 20px;margin-top: 20px;">
      <div class="filter-container">
        <div class="block">
          <!-- <el-input v-model="listQuery.sn" style="width: 200px;" class="filter-item" placeholder="DeviceNo" @keyup.enter.native="searchTable" /> -->

          <el-date-picker v-model="listQuery.value5" :end-placeholder="$t('yhubReport.endDate')" :range-separator="$t('yhubReport.to')" :start-placeholder="$t('yhubReport.startDate')" type="daterange" @change="searchTable" />
          <el-select v-model="listQuery.event" :placeholder="$t('QR.selectEvent')" clearable @change="searchTable">
            <el-option v-for="(item,index) in chargerOption" :key="index" :label="item.label" :value="item.value" />
          </el-select>
          <!-- <el-input v-model="listQuery.curveNo" clearable placeholder="DeviceNo" class="input-with-select deviceNameTable" @keyup.enter.native="changeSearch(tableObj.deviceName)">
          <el-button slot="append" icon="el-icon-search" @click="searchTable" />
          </el-input>-->
          <!-- <el-button class="filter-item" type="primary" icon="el-icon-search" @click="searchTable">Search</el-button> -->
          <el-button class="filter-item" icon="el-icon-download" style="margin-top: -4px;margin-bottom: 0;float: right;margin: 0 10px;" type="primary" @click="_downLoadExcel" />

          <el-button type="primary" icon="el-icon-refresh" style="margin-top: -4px;margin-bottom: 0;float: right;margin: 0 10px;" @click="queryList" />
        </div>
      </div>

      <el-table v-loading.body="listLoading" :data="list" border element-loading-text="Loading" fit highlight-current-row>
        <!-- <el-table-column label="Device Sn" width="90" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sn }}</span>
        </template>
        </el-table-column>-->

        <!-- <el-table-column :label="$t('QR.Date')" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.startTime,0) }}</span>
          </template>
        </el-table-column> -->

        <el-table-column prop="chargeTime" :label="$t('warningPage.CreatedAt')" align="center" min-width="120px" />

        <el-table-column :label="$t('QR.EventRecords')" align="center" min-width="220">
          <template slot-scope="scope">
            <span>{{ $t('chargerIndex.event_' + scope.row.event) }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('QR.StartTime')" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.startTime,1) }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('QR.StartV')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.startV }} V</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.Duration')" align="center">
          <template slot-scope="scope">
            <span>{{ formatTimeDuration1(scope.row.duration) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.EndV')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.endV }} V</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.ChargedAH')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.chargedAh }} Ah</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.Profile')" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.curveNo }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.ACVoltage')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.voltageAc }} V</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.BTS')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.temperature }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList" :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page" layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { pageList, chargerDetailList, downLoadExcel } from '@/api/QR'
import { pagination } from '@/utils/init_table'
import timezoons from '@/utils/timezones.json'
import { temChangeUnit } from '@/utils/temChange.js'
import { touchChargerRecord } from '@/api'
import { getDateAndHour, howLongAgo } from '@/utils/updateTime.js'
export default {

  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      basicinfo: {},
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: '',
        curveNo: null,
        value5: '',
        sn: this.$route.query.sn,
        event: null
      },
      pageshow: true,
      // 分页----end
      fileList: [],
      dialogStatus: '',
      uploadFileDialog: false,
      uploading: false,
      options: timezoons,
      value: '',
      stopTimeOut: false
    }
  },
  computed: {
    mcuId() {
      return this.$route.query.mcuId
    },
    chargerOption() {
      return this.$store.state.chargerOption
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    if (this.$route.query.sn) {
      this.listQuery.sn = this.$route.query.sn
    }
    this.queryList()
    this.queryBasicinfo()
    this._touchChargerRecord() // 触发充电器更新记录
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    this.stopTimeOut = true
  },
  methods: {
    _touchChargerRecord() {
      if (!this.mcuId) return
      touchChargerRecord(this.mcuId).then(res => {
        // if (!this.stopTimeOut) {
        //   setTimeout(() => {
        //     this._touchChargerRecord()
        //   }, 15000);
        // }
      })
    },
    queryList() {
      this.listLoading = true
      console.log(this.listQuery)
      var param = {
        // "curveNo": "string",
        sn: this.listQuery.sn,
        event: this.listQuery.event,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.listQuery.value5) {
        param.d1 = this.listQuery.value5[0].getTime()
        param.d2 = this.listQuery.value5[1].getTime() + 24 * 60 * 60 * 1000 - 1
      }
      chargerDetailList(param).then(res => {
        console.log('记录：', res)
        this.list = res.resultModel.list || []

        this.list.forEach(v => {
          v.temperature = temChangeUnit(v.temperature)
          if (v.startTime) v.chargeTime = getDateAndHour(this.get8(v.startTime), 'noSecond')
        })
        this.listQuery.pageInfo.total = res.resultModel.total
        this.listLoading = false
      })
    },
    queryBasicinfo() {
      var param = {
        companyIdList: [],
        sn: this.listQuery.sn,
        pageNum: 1, // 分页--选中某一页
        pageSize: 10 // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(response => {
        if (response.resultModel && response.resultModel.list && response.resultModel.list.length > 0) {
          this.basicinfo = response.resultModel.list[0]
          if (this.basicinfo.warrantyDate) {
            this.basicinfo.warrantyDate = this.basicinfo.warrantyDate.split('T')[0]
          }
          if (this.basicinfo.makeDate) { this.basicinfo.makeDate = this.basicinfo.makeDate.split('T')[0] }
        }
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    formatTime(s, i) {
      // 时间截取
      if (s) {
        s = s.split(' ')
        return s[i]
      }
      return s
    },
    formatTimeDuration(s) {
      //
      if (s !== null && s !== '') {
        var timeStr
        var hour = 0
        var minute = 0
        var second = 0
        if (s <= 0) {
          return '00:00'
        } else {
          minute = s / 60
          if (minute < 60) {
            second = s % 60
            timeStr = this.unitFormat(minute) + ':' + this.unitFormat(second)
          } else {
            hour = minute / 60
            if (hour > 99) {
              return '99:59:59'
            }
            minute = minute % 60
            second = s - hour * 3600 - minute * 60
            timeStr = this.unitFormat(hour) + ':' + this.unitFormat(minute) + ':' + this.unitFormat(second)
          }
        }
        return timeStr
      } else {
        return ''
      }
    },
    formatTimeDuration1(s) {
      // 持续时间
      if (s !== null && s !== '') {
        var timeStr
        var hour = 0
        var minute = 0
        var second = 0
        if (s <= 0) {
          return '0 s'
        } else {
          minute = s / 60
          if (minute < 60) {
            second = s % 60
            timeStr = minute + ' min ' + second + ' s'
          } else {
            hour = Math.floor(minute / 60)
            // if (hour > 99) {
            //   return '99:59:59'
            // }
            minute = Math.floor(minute % 60)
            second = s - hour * 3600 - minute * 60
            timeStr = hour + ' h ' + minute + ' min ' + second + ' s'
            if (second == 0) timeStr = hour + ' h ' + minute + ' min '
          }
        }
        return timeStr
      } else {
        return ''
      }
    },
    unitFormat(i) {
      // 时间转换
      var retStr = '00'
      if (i >= 0 && i < 10) {
        retStr = '0' + Math.round(i)
      } else if (i >= 0) {
        retStr = '' + parseInt(i)
      }
      return retStr
    },
    _downLoadExcel() {
      // 下载
      // this.listQuery.tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // downLoadExcel(this.listQuery)

      var param = {
        sn: this.listQuery.sn,
        pageNum: 1,
        pageSize: 20000
      }
      if (this.listQuery.value5) {
        param.d1 = this.listQuery.value5[0].getTime()
        param.d2 = this.listQuery.value5[1].getTime() + 24 * 60 * 60 * 1000 - 1
      }
      chargerDetailList(param).then(res => {
        // console.log('全记录：', res)
        const list = res.resultModel.list || []
        list.forEach(v => {
          v.temperature = temChangeUnit(v.temperature)
          if (v.startTime) v.chargeTime = getDateAndHour(this.get8(v.startTime), 'noSecond')
        })

        console.log(list)

        // 导出excel
        import('@/utils/Export2Excel').then(excel => {
          const tHeader = [
            this.$t('warningPage.CreatedAt'),
            this.$t('QR.EventRecords'),
            this.$t('QR.StartV'),
            this.$t('QR.Duration'),
            this.$t('QR.EndV'),
            this.$t('QR.ChargedAH'),
            this.$t('QR.Profile'),
            this.$t('QR.ACVoltage'),
            this.$t('QR.BTS')
          ]
          const filterVal = [
            'chargeTime',
            'event',
            'startV',
            'duration',
            'endV',
            'chargedAh',
            'curveNo',
            'voltageAc',
            'temperature'
          ]
          // const list = this.chargedRecordsList
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'chargrRecord_' + this.getNowFormatDate(),
            autoWidth: true,
            bookType: 'xlsx'
          })
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j == 'event') {
            return this.$t('chargerIndex.event_' + v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    getNowFormatDate() { // 获取当前时间
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var strDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
        ' ' + date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds()
      return currentdate
    },
    get8(time) {
      // let timezone = 8
      // let offset = new Date().getTimezoneOffset()
      // console.log(offset)
      const nowdate = new Date(time + ' GMT+0800').getTime()
      return nowdate
    }
  }
}
</script>
